const getIsDifmAllowedForVehicleFitment = (isVehicleFit: boolean, isUniversal: boolean, makeName?: string) => {
  if (!isVehicleFit && makeName) {
    return false
  }

  if (isUniversal) {
    return false
  }

  return true
}

export default getIsDifmAllowedForVehicleFitment
